import { useEffect, useState } from 'react';

// Кнопка «Наверх»: появляется, когда страницу пролистали далеко вниз.
export default function ScrollTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow((window.scrollY || document.documentElement.scrollTop || 0) > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return (
    <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Наверх" title="Наверх"
      style={{ position: 'fixed', right: 14, bottom: 30, zIndex: 350, width: 44, height: 44, borderRadius: 22, border: 'none',
        background: 'var(--accent)', color: '#fff', fontSize: 22, lineHeight: '44px', textAlign: 'center', cursor: 'pointer',
        boxShadow: '0 4px 14px rgba(0,0,0,.25)', opacity: .92 }}>↑</button>
  );
}
